<script setup lang="ts">
const { t } = useI18n();
const shopStore = useShopStore();

definePageMeta({
	middleware: "mobile-relay"
});

useSeoMeta({
	title: () => t("meta.index.title"),
	ogTitle: () => t("meta.index.ogTitle"),
	description: () => t("meta.index.description"),
	ogDescription: () => t("meta.index.ogDescription")
});

await useAsyncData("/shop/products-count, /shop/products, /shop/products-interactive", () => Promise.all(
	[
		shopStore.getProductsCount(),
		shopStore.getBestSellingProducts(),
		shopStore.getInteractiveProducts()
	]
)
);
</script>

<template>
	<div class="box-content px-4 xs:px-4">
		<!-- <HomeSwiper /> -->
		<HomeCards class="mt-4" />
		<HomeGallery class="mt-11 max-w-[1400px] m-auto" />
		<HomeCollection class="mt-11" />
		<CommonAdvantages class="py-11 max-w-[1280px] m-auto sm:py-8 xs:py-8" />
	</div>
</template>
